<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>Start/Stop/Transfer</h2>
  </div>
</div>

<div class="row flex-row">
  <div class="col-sm-6 col-md-4 flex-col">
    <div class="panel panel-card panel-split">
      <div class="split-left">
        <i class="fas fa-plug profile-icons"></i>
      </div>
      <div class="split-right">
        <div class="split-text">
          <h3 class="split-title">Start Electric Service</h3>
          <p>Start electric service at a new or existing location.</p>
        </div>
        <div class="link-out">
          <br />
          <a class="btn btn-link-directional" title="GO" routerLink="/CustService/StartService/FindAddress">START SERVICE<i class="fa fa-chevron-right icon-spacing-left"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6 col-md-4 flex-col">
    <div class="panel panel-card panel-split">
      <div class="split-left">
        <i class="fas fa-hand-paper profile-icons"></i>
      </div>
      <div class="split-right">
        <div class="split-text">
          <h3 class="split-title">Stop Electric Service</h3>
          <p>Stop electric service at an existing location.</p>
        </div>
        <div class="link-out" style="margin-top: 13%;">
          <a class="btn btn-link-directional" title="GO" routerLink="/MyProfile/Alerts">STOP SERVICE<i class="fa fa-chevron-right icon-spacing-left"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6 col-md-4 flex-col">
    <div class="panel panel-card panel-split">
      <div class="split-left">
        <i class="fas fa-truck profile-icons"></i>
      </div>
      <div class="split-right">
        <div class="split-text">
          <h3 class="split-title">Transfre Electric Service</h3>
          <p>Transfer electric service from an existing location to a new location.</p>
        </div>
        <div class="link-out" style="margin-top:7%;">
          <a class="btn btn-link-directional" title="GO" routerLink="/MyProfile/ContactInfo">TRANSFER SERVICE<i class="fa fa-chevron-right icon-spacing-left"></i></a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row info-box">
  <app-info-message [infoMsg]="message"></app-info-message>
</div>



// WEBPACK FOOTER //
// ./src/app/start-stop-move/start-stop-move.component.html